module.exports = __webpack_public_path__ + "static/img/1.db39e923.png";